export { CustomerRegister } from './CustomerRegister';
